module.exports = __webpack_public_path__ + "img/140002.67a96d6b.png";